import { AutoMap } from "@automapper/classes";
import { PointagePauseDTO } from "./pointage-pause.dto";
import { VehiculeDTO } from "./vehicule.dto";

export class PointageJournalierDTO {
    @AutoMap()
    departDomicile?: string;
    @AutoMap()
    debutJournee!: string;
    @AutoMap()
    finJournee!: string;
    @AutoMap()
    arriveeDomicile?: string;
    @AutoMap()
    vehicule: VehiculeDTO = new VehiculeDTO()
    @AutoMap(() => [PointagePauseDTO])
    pointagePauseList: PointagePauseDTO[] = [];
}